import { BuildBrand } from 'config/buildConfig';
import { chadebebeTheme } from './chadebebeTheme';
import { listacasamentoTheme } from './listacasamentoTheme';
import { presentearTheme } from './presentearTheme';
import { BrandThemeTokens } from './types';

export const THEME_TOKENS: Record<BuildBrand, BrandThemeTokens> = {
  presentear: presentearTheme,
  chadebebe: chadebebeTheme,
  listacasamento: listacasamentoTheme,
  chadebb: presentearTheme,
};

export type { BrandThemeTokens };
